import React, { Component } from 'react';
import GameTypeSection from './GameTypeSection';

export default class ChoosePlayOptionsComponent extends Component {

	render() {
		const { friendlies, ranked, playerCount, ...props } = this.props;

		if(friendlies.length === 0 && ranked.length === 0) {
			return null;
		}
		return (
			<div className='games flex'>
				<div className='game_section'>
					<h3 className='main_heading'>
						{playerCount === 1 &&
						<React.Fragment>
							<span className='text'>Singles</span>
							<span className='cutie_pie'>
								<i className='fa fa-user' />
								<span className='versus'>vs</span>
								<i className='fa fa-user' />
							</span>
						</React.Fragment>
						}
						{playerCount === 2 &&
						<React.Fragment>
							<span className='text'>Doubles</span>
							<span className='cutie_pie'>
								<i className='fa fa-user' />
								<i className='fa fa-user' />
								<span className='versus'>vs</span>
								<i className='fa fa-user' />
								<i className='fa fa-user' />
							</span>
						</React.Fragment>
						}
					</h3>
					<div className='game_types'>
						<GameTypeSection
							title='Friendlies'
							options={friendlies}
							{...props}
						/>
						<GameTypeSection
							title='Ranked'
							options={ranked}
							{...props}
						/>
					</div>
				</div>
			</div>
		);
	}
}